import { c7Api } from './c7Api';

class Statistics {
    
    private static statsInstance: Statistics;
    private baseUrl:string = "api/stat"

    private constructor() { }

    public static GetInstance(): Statistics {
        if(!Statistics.statsInstance){
            Statistics.statsInstance = new Statistics();
        }
        return Statistics.statsInstance;
    }
    
    public async RegisterStat(data:any): Promise<any> {    
  return await c7Api.post(this.baseUrl, data);
}


}

  export const statisticsLogic = Statistics.GetInstance();